import React from 'react';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox'

/* BCA modules*/
import {DisabledReasonTooltip} from "../../../../../../components/Tooltip";
import useStyles from './styles';

export default (props) => {
  const classes = useStyles();

  const onValueChange = fieldname => (event, checked) => {
    props.handleChanged(fieldname)(checked);
  };

  return (
    <div className={classes.container}>
      <FormControl disabled={props.disabled} component="fieldset">
        <FormLabel
          component="legend"
          classes={{root: classes.formLabel, focused: classes.focusedLabel}}
        >
          {props.label || 'Inhalte'}
        </FormLabel>
        {props.options.map((item) => {
          const disabled = item.disabled || (props.isDepotStatus && item.isDisabledForDepotStatus);
          return (
            <DisabledReasonTooltip title={item.tooltip} placement={"top"}>
              <FormControlLabel
                key={item.value}
                label={item.description}
                classes={{label: classes.formControlLabel}}
                control={
                  <Checkbox
                    color="primary"
                    disabled={disabled}
                    classes={{root: classes.radio}}
                    checked={props.settings[item.value] && !disabled}
                    onChange={onValueChange(item.value)}
                  />
                }
              />
            </DisabledReasonTooltip>
          )
        })}
      </FormControl>
    </div>
  )
}